// ======================================
// Materials & Brands Page Module
// ======================================

import { icons } from '../components.js';
import { materials } from '../data.js';

export function renderMaterialsPage() {
  return `
    <section class="page-header">
      <div class="container">
        <div class="page-header-content">
          <h1 class="page-title">Materials & Brands</h1>
          <p class="page-subtitle">
            We partner with only the best brands to ensure your interiors 
            stand the test of time. Complete transparency on what goes into your home.
          </p>
        </div>
      </div>
    </section>

    <!-- Materials Grid -->
    <section class="section" style="background-color: var(--color-base);">
      <div class="container">
        ${materials.map(category => `
          <div class="materials-category">
            <h2 class="category-title">${category.category}</h2>
            <div class="brands-grid">
              ${category.items.map(item => `
                <div class="brand-card">
                  <div class="brand-card-header">
                    <h3 class="brand-name">${item.name}</h3>
                    <span class="brand-type">${item.type}</span>
                  </div>
                  <div class="brand-warranty">
                    ${icons.shield}
                    <span>${item.warranty} Warranty</span>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `).join('')}
      </div>
    </section>

    <!-- Why We Choose These Section -->
    <section class="section" style="background-color: var(--color-surface);">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">Why We Choose These Brands</h2>
          <p class="section-subtitle">
            Every brand and material is carefully selected based on quality, durability, and value.
          </p>
        </div>
        <div class="why-us-grid">
          <div class="why-us-card">
            <div class="why-us-icon">${icons.shield}</div>
            <h3 class="why-us-title">Tested & Certified</h3>
            <p class="why-us-desc">All materials are ISI certified and tested for durability, moisture resistance, and safety.</p>
          </div>
          <div class="why-us-card">
            <div class="why-us-icon">${icons.award}</div>
            <h3 class="why-us-title">Industry Leaders</h3>
            <p class="why-us-desc">We work only with brands that have proven track records and excellent after-sales support.</p>
          </div>
          <div class="why-us-card">
            <div class="why-us-icon">${icons.calculator}</div>
            <h3 class="why-us-title">Best Value</h3>
            <p class="why-us-desc">Our partnerships allow us to offer premium quality at competitive prices.</p>
          </div>
          <div class="why-us-card">
            <div class="why-us-icon">${icons.clock}</div>
            <h3 class="why-us-title">Readily Available</h3>
            <p class="why-us-desc">All our materials are stocked locally, ensuring no delays in your project timeline.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Warranty Section -->
    <section class="section" style="background-color: var(--color-base);">
      <div class="container">
        <div class="warranty-banner">
          <div class="warranty-content">
            <div class="warranty-icon">${icons.shield}</div>
            <div>
              <h2 class="warranty-title">10-Year Comprehensive Warranty</h2>
              <p class="warranty-desc">
                Every NammaVeetuInteriors project comes with a 10-year warranty covering 
                materials, hardware, and workmanship. Peace of mind, guaranteed.
              </p>
            </div>
          </div>
          <a href="/contact" class="btn btn-primary btn-lg">Get Started</a>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="section cta-section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">Questions About Materials?</h2>
          <p class="cta-subtitle">
            Our experts can explain the pros and cons of each option for your specific needs.
          </p>
          <button class="btn btn-lg cta-btn" data-open-modal="lead-modal">
            Talk to an Expert
          </button>
        </div>
      </div>
    </section>
  `;
}
